import React, { useState } from 'react';

const AiExpandModal = ({ isOpen, onClose, brandName, themeName, onConfirm }) => {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [selectedWords, setSelectedWords] = useState([]);

  const handleGenerate = async () => {
    if (!brandName || !themeName) return alert('缺少品牌名称或业务主题');
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/ai-expand/expand-keywords', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ brandName, themeName, count: 50 })
      });
      const data = await res.json();
      if (data.keywords) {
        setResults(data.keywords);
        setSelectedWords(data.keywords.map(k => ({ word: k.word, keywordType: k.category })));
      }
    } catch (err) {
      console.error(err);
      alert('拓词失败，请稍后重试');
    }
    setLoading(false);
  };

  const handleToggle = (k) => {
    setSelectedWords(prev => prev.some(w => w.word === k.word) ? prev.filter(w => w.word !== k.word) : [...prev, { word: k.word, keywordType: k.category }]);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-slate-800 w-[600px] max-w-full rounded-xl shadow-2xl overflow-hidden flex flex-col max-h-[80vh]">
        <div className="px-6 py-4 border-b border-gray-100 dark:border-slate-700 flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2">
            ✨ AI 智能拓词 - {themeName}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">&times;</button>
        </div>
        <div className="p-6 overflow-y-auto flex-1">
          {results.length === 0 && !loading ? (
            <div className="text-center py-10">
              <p className="text-gray-500 dark:text-slate-400 mb-4">点击下方按钮，AI将根据品牌【{brandName}】和业务【{themeName}】生成关键词</p>
              <button onClick={handleGenerate} className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors">
                开始生成
              </button>
            </div>
          ) : loading ? (
            <div className="flex flex-col items-center justify-center py-10 space-y-4">
              <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-gray-500">AI 正在疯狂燃烧算力生成中...</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div className="flex justify-between items-center bg-gray-50 dark:bg-slate-700/30 p-2 rounded-lg border border-gray-100 dark:border-slate-700">
                <div className="flex items-center gap-3">
                  <span className="text-sm text-gray-600 dark:text-slate-300 font-medium">已选 <span className="text-indigo-600 dark:text-indigo-400">{selectedWords.length}</span> / {results.length}</span>
                  <div className="h-4 w-px bg-gray-300 dark:bg-slate-600"></div>
                  <button 
                    onClick={() => setSelectedWords(results.map(k => ({ word: k.word, keywordType: k.category })))}
                    className="text-sm text-gray-500 hover:text-indigo-600 dark:text-slate-400 dark:hover:text-indigo-400 transition-colors"
                  >
                    全选
                  </button>
                  <button 
                    onClick={() => setSelectedWords([])}
                    className="text-sm text-gray-500 hover:text-orange-600 dark:text-slate-400 dark:hover:text-orange-400 transition-colors"
                  >
                    全不选
                  </button>
                </div>
                <button onClick={handleGenerate} className="text-sm font-medium text-indigo-600 hover:text-indigo-700 dark:text-indigo-400 dark:hover:text-indigo-300 flex items-center gap-1 transition-colors">
                  <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
                  换一批
                </button>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {results.map((k, i) => (
                  <label key={i} className={`flex items-start gap-2 p-3 rounded-lg border cursor-pointer transition-colors ${selectedWords.some(w => w.word === k.word) ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-500/10' : 'border-gray-200 dark:border-slate-700'}`}>
                    <input type="checkbox" className="mt-1" checked={selectedWords.some(w => w.word === k.word)} onChange={() => handleToggle(k)} />
                    <div className="flex-1 min-w-0">
                      <div className="font-medium text-gray-900 dark:text-white text-sm truncate" title={k.word}>{k.word}</div>
                      <div className="flex gap-2 mt-1 text-xs text-gray-500">
                        <span className={`px-1.5 py-0.5 rounded ${k.category === 'brand' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300 font-medium' : k.category === 'competitor' ? 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300 font-medium' : k.category === 'compare' ? 'bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300 font-medium' : 'bg-slate-100 text-slate-700 dark:bg-slate-700/50 dark:text-slate-300 font-medium'}`}>{k.category === 'brand' ? '品牌词' : k.category === 'competitor' ? '竞品词' : k.category === 'compare' ? '对比词' : k.category === 'general' ? '通用词' : k.category}</span>
                        <span className="text-orange-500">🔥 {k.searchVolume}</span>
                      </div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="px-6 py-4 border-t border-gray-100 dark:border-slate-700 flex justify-end gap-3 bg-gray-50 dark:bg-slate-900/50">
          <button onClick={onClose} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg">取消</button>
          <button 
            onClick={() => onConfirm(selectedWords.map(w => ({ keyword: w.word, keywordType: w.keywordType })))} 
            disabled={loading || selectedWords.length === 0}
            className="px-4 py-2 text-sm text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg disabled:opacity-50"
          >
            应用选中词
          </button>
        </div>
      </div>
    </div>
  );
};
export default AiExpandModal;
